import { ActionTree } from 'vuex';
import ApiUrl from '../../../../api/url';
import { ApplicationFormWorkAccountState } from './types';
import { RootState } from '../../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../../error-type';

export const actions: ActionTree<ApplicationFormWorkAccountState, RootState> = {
    /**
     * 作業担当ユーザー一覧取得(SAML用)
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} userId ユーザーID
     * @param {any} pageNumber ページ番号
     * @param {any} perPage ページ毎の表示件数
     * @param {any} sort ソートするカラムと順番
     * @param {any} nodeAccountId ノードアカウントID
     * @returns {Promise<void>}
     */
    async curernt_saml({ dispatch, commit }, { userId, nodeAccountId, pageNumber, perPage, sort } = {}) {
        const payload = {
            node_account_id: nodeAccountId,
            page_number: pageNumber,
            per_page: perPage,
            'sort[column]': sort.column,
            'sort[direction]': sort.direction,
        };
        try {
            commit(types.CURRENT_SAML_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.User.ApplicationFormWorkAccount.CURRENT_SAML.replace(':user_id', userId),
                    params: payload,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.CURRENT_SAML_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.CURRENT_SAML_FAILURE, params);
        }
    },

    /**
     * 作業担当ユーザー一覧省略取得(SAML用)
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} userId ユーザーID
     * @param {any} nodeAccountId ノードアカウントID
     * @returns {Promise<void>}
     */
    async curernt_saml_skip({ dispatch, commit }, { userId, nodeAccountId } = {}) {
        const payload = {
            node_account_id: nodeAccountId,
        };
        try {
            commit(types.CURRENT_SAML_SKIP_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.User.ApplicationFormWorkAccount.CURRENT_SAML_SKIP.replace(':user_id', userId),
                    params: payload,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.CURRENT_SAML_SKIP_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.CURRENT_SAML_SKIP_FAILURE, params);
        }
    },
};
